import { CardElement } from "@stripe/react-stripe-js";
import { StoreGatewayModel } from "../../models";
import { GatewayEnum } from "../../enums";
import { Form } from "react-bootstrap";
import { usePayment } from "../../context";

const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      color: "#32325d",
      fontSize: "16px",
      "::placeholder": {
        color: "#aab7c4",
      },
    },
    invalid: {
      color: "#fa755a",
      iconColor: "#fa755a",
    },
  },
};

type Props = {
  gateway: StoreGatewayModel;
  isChecked?: boolean;
  handlePaymentModeChange: (gateway_id: GatewayEnum, mode: string) => void;
};

const PayWithStripe: React.FC<Props> = ({
  gateway,
  isChecked,
  handlePaymentModeChange,
}) => {
  const { setSaveCard } = usePayment();

  return (
    <>
      <div
        className={
          isChecked
            ? "payment-method-active"
            : "choose_payment_method_colm card mb-3"
        }
      >
        <div className="card_viza card_viza2">
          <label>
            <span>
              <input
                type="radio"
                id="pay_with_stripe"
                name="payment_mode"
                value={gateway.gateway_id}
                checked={isChecked}
                onChange={() =>
                  handlePaymentModeChange(gateway.gateway_id, "credit")
                }
              />{" "}
              Credit Card
            </span>
          </label>
        </div>
        <div className={`p-4 ${isChecked ? "d-block" : "d-none"}`}>
          <div className="h6 card-detail-text">ENTER YOUR CARD DETAILS</div>
          <div
            id="stripe-container"
            className="mb-3 rounded p-3"
            style={{ border: "1px solid #d9d9d9" }}
          >
            <CardElement options={CARD_ELEMENT_OPTIONS} />
          </div>
          <Form.Check
            id="save_card_stripe"
            type="checkbox"
            name="save_card_stripe"
            size={24}
            label="Save this card for later?"
            onChange={(e) => setSaveCard(e.target.checked)}
          />
        </div>
      </div>
    </>
  );
};

export default PayWithStripe;
